import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';
@Component({
  selector: 'counter-buttons',
  templateUrl: './counter-buttons.component.html',
  styleUrls: ['./counter-buttons.component.scss'],
})
export class CounterButtonsComponent implements OnInit {
  @Output('addFunction') addFunction: EventEmitter<any> = new EventEmitter();
  @Output('removeFunction') removeFunction: EventEmitter<any> =
    new EventEmitter();
  @Input() item: any;
  @Input() quantity: any;
  @Input() containerStyle: any;
  /**
   * Shows an in-place progress border and blocks both buttons while this line
   * is being updated — used instead of a global loading overlay.
   */
  @Input() busy = false;

  constructor(private analyticsService: AnalyticsService) {}

  ngOnInit() {}

  async CallAddFunction(item) {
    this.analyticsService.trackUnified('counter_increment_clicked', {
      flow: 'shared',
      outcome: 'success',
      legacy_event_name: 'button_clicked',
      component: 'counter-buttons-component',
      button: 'increase-counter-button',
    });
    this.addFunction.emit(item);
  }
  async CallRemoveFunction(item) {
    this.analyticsService.trackUnified('counter_decrement_clicked', {
      flow: 'shared',
      outcome: 'success',
      legacy_event_name: 'button_clicked',
      component: 'counter-buttons-component',
      button: 'decrease-counter-button',
    });
    this.removeFunction.emit(item);
  }
}
